<template>
  <v-data-table
    mobile-breakpoint="0"
    :headers="headers"
    :items="tasks"
    item-key="_id"
    :loading="isLoading"
    loading-text="Đang tải danh sách công việc..."
    sort-by="createdAt"
    disable-sort
  >
    <template v-slot:item.title="{ item }">
      <div style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap" :title="item.title">
        {{ item.title }}
      </div>
    </template>
    <template v-slot:item.priority="{ item }">
      <v-chip class="white--text" :color="priorityColor(item.priority)" text-color="white">
        {{ priorityText(item.priority) }}
      </v-chip>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip class="white--text" :color="statusColor(item.status)" text-color="white">
        {{ statusText(item.status) }}
      </v-chip>
    </template>

    <template v-slot:item.creatorData="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="mt-2 mr-2 mb-2 d-flex align-center justify-center"
            v-on="on"
            v-bind="attrs"
            style="width: 40px; height: 40px; border-radius: 8px; background-color: darkgrey; color: white"
          >
            <span class="white--text">{{ getVietnameseInitials(item.creatorData.name) }}</span>
          </div>
        </template>
        <span>
          {{ item.creatorData.name || item.creatorData.username || '---' }}
        </span>
      </v-tooltip>
    </template>

    <template v-slot:item.receiversData="{ item }">
      <div class="d-flex">
        <v-tooltip v-for="(receiver, idx) in item.receiversData.slice(0, 7)" :key="receiver._id || idx" top>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="mt-2 mb-2 mr-2 d-flex align-center justify-center"
              v-on="on"
              v-bind="attrs"
              @mouseenter="hoveredAvatar = receiver._id || idx"
              @mouseleave="hoveredAvatar = null"
              style="width: 40px; height: 40px; border-radius: 8px; background-color: darkgrey; color: white"
            >
              <span class="white--text">{{ getVietnameseInitials(receiver.name) }}</span>
            </div>
          </template>
          <span>{{ receiver.name }}</span>
        </v-tooltip>
        <v-tooltip top v-if="item.receiversData.length > 7">
          <template #activator="{ on, attrs }">
            <div
              v-on="on"
              v-bind="attrs"
              class="mt-2 mb-2 mr-2 d-flex align-center justify-center"
              style="width: 40px; height: 40px; background-color: darkgrey; border-radius: 8px"
            >
              <span class="white--text" style="font-size: 14px">+{{ item.receiversData.length - 7 }}</span>
            </div>
          </template>
          <span class="white--text" style="white-space: pre-line">{{
            item.receiversData
              .slice(7)
              .map(u => u.name || u.username)
              .join('\n')
          }}</span>
        </v-tooltip>
      </div>
    </template>

    <template v-slot:item.due_date="{ item }">
      {{ item.due_date | ddmm }}
    </template>

    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | ddmm }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn icon small @click="$emit('viewTask', item)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="$emit('onChange', item)">
            <v-list-item-title>Chuyển trạng thái</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list>
          <v-list-item @click.stop="$emit('onDelete', item)">
            <v-list-item-title>Xoá công việc</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import get from 'lodash-es/get'
import { mapGetters } from 'vuex'

export default {
  props: {
    tasks: Array,
    isLoading: Boolean,
  },
  data() {
    return {
      hoveredAvatar: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    headers() {
      return [
        { text: 'Tên công việc', value: 'title' },
        { text: 'Người giao việc', value: 'creatorData' },
        { text: 'Người nhận việc', value: 'receiversData' },
        { text: 'Ưu tiên', value: 'priority' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Hạn hoàn thành', value: 'due_date' },
        { text: 'Ngày tạo', value: 'createdAt' },
        { text: 'Thao tác', value: 'actions', sortable: false },
      ]
    },
  },
  methods: {
    avatar(item) {
      const url = get(item, 'avatar.url')
      return url || require('@/assets/default-avatar.svg')
    },
    priorityText(val) {
      const map = ['Khẩn cấp', 'Cao', 'Bình thường', 'Thấp', 'Rất thấp']
      return map[val] || '-'
    },
    priorityColor(val) {
      const map = ['red', 'orange', 'blue', 'grey darken-1', 'grey']
      return map[val] || 'grey'
    },
    statusText(status) {
      const map = {
        not_started: 'Chưa bắt đầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        waiting: 'Chờ đánh giá',
      }
      return map[status] || '-'
    },
    statusColor(status) {
      const map = {
        not_started: 'grey',
        in_progress: 'orange',
        completed: 'green',
        waiting: 'blue',
      }
      return map[status] || 'grey'
    },
    getVietnameseInitials(name) {
      if (!name || typeof name !== 'string') return ''
      const words = name.trim().split(/\s+/)
      if (words.length === 1) {
        return words[0][0].toUpperCase()
      }
      const lastTwo = words.slice(-2)
      return lastTwo.map(word => word[0].toUpperCase()).join('')
    },
  },
}
</script>

<style scoped>
.hovered-avatar {
  transform: scale(1.05);
  outline: 1px solid #0560b4;
  outline-offset: 0px;
  border-radius: 8px;
}
</style>
